export default {
  WHATSAPP: 1,
  TWITTER: 2,
  YOUTUBE: 3,
  TIKTOK: 4,
  FACEBOOK: 5,
  INSTAGRAM: 6,
  EMAIL: 7,
  VIDEO: 8,
  CUSTOM: 9,
  ECOMMERCE: 10,
  ANDROID: 11,
  IOS: 12,
  MAPS: 13,
};
